// @ts-ignore
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import toast, { Toaster } from "react-hot-toast";

import { StyledColor } from "../../interface/index";
import colors from "../../assets/colors/colors";
import mainStore from "../../store/index";
import { API } from "../../utils/config";
import Loader from "../../components/utils/Loader";
import Header from "../../components/layout/Header";
import { PostChangePassword } from "../../API";

import {
  OAuthCredential,
  getAuth,
  signInWithEmailAndPassword,
  IdTokenResult,
} from "firebase/auth";

export default function Login() {
  let navigate = useNavigate();
  const STORE = mainStore();

  const [form, setForm] = useState<any>({
    email: "",
    password: "",
  });

  const [isloader, setLoader] = useState<boolean>(false);
  const [isValid, setIsValid] = useState(false);
  const [message, setMessage] = useState("");
  const [changepass, setChangePass] = useState<boolean>(false);

  useEffect(() => {
    const islogged = localStorage.getItem("token");
    if (islogged) {
      navigate("/admin-restaurant");
    }
  }, []);

  const handleLogin = async () => {
    setLoader(true);

    const auth = getAuth();
    signInWithEmailAndPassword(auth, form.email, form.password)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user as any;
        let token: any = user.accessToken;
        localStorage.setItem("token", token);
        localStorage.setItem("email", user.email || "");
        localStorage.setItem("localId", user.uid || "");
        localStorage.setItem("user_id", user.uid || "");
        setLoader(false);
        STORE.handleUserlogged(true);
        STORE.handledLogged(true);

        navigate("/admin-restaurant");
      })
      .catch((error) => {
        console.log(error, "error user");
        const errorCode = error.code;
        const errorMessage = error.message;
      });

    return;
  };

  const emailRegex = /\S+@\S+\.\S+/;

  const onChange = (e: any) => {
    const value = e.target.value;
    const index = e.target.id;

    if (index === "email") {
      if (emailRegex.test(value)) {
        setIsValid(true);
        setMessage("Correo valido🙌");
      } else {
        setIsValid(false);
        setMessage("Introduce un correo valido😬");
      }
    }

    form[index] = value;
    setForm({
      ...form,
    });
  };

  const handleChangePassword = async () => {
    const response = await PostChangePassword(form.email);
    if (response.data.status_code === 200) {
      setChangePass(true);
      toast.success("Cambio de contraseña enviado a tu correo", {
        duration: 50000,
      });
    } else {
      setChangePass(false);
      toast.error("Este correo no esta registrado en nuestra aplicación❌");
      return;
    }
  };

  return (
    <>
      <Header />
      <ContentLogin color={colors}>
        <div className="login">
          <header>
            <h1>Menu DR</h1>
            <h6>Iniciar sesión</h6>
          </header>
          <div className="form">
            <div>
              <label>Email</label>
              <input
                type="text"
                className="form-control shadow-none"
                placeholder="correo@yourcorreo.com"
                id="email"
                onChange={onChange}
                value={form.email}
              />
              <span className={`${isValid ? "text-success" : "text-danger"}`}>
                {message}
              </span>
            </div>
            <div>
              <label>Contraseña</label>
              <input
                type="password"
                className="form-control shadow-none"
                placeholder="*********"
                id="password"
                onChange={onChange}
                value={form.password}
              />
            </div>

            {isloader && (
              <div className="w-100 text-center">
                <Loader color="#3498db" />
              </div>
            )}
            <div>
              {!isloader && (
                <button
                  className="btn btn-primary d-block w-100"
                  onClick={() => handleLogin()}
                >
                  Acceder
                </button>
              )}
            </div>
            <div className="">
              <Link to="/register">Crear cuenta</Link>
              <br />
              {!changepass && (
                <a href="#" onClick={() => handleChangePassword()}>
                  ¿Has olvidado tu contraseña?
                </a>
              )}
            </div>
          </div>
        </div>
        <Toaster position="bottom-center" reverseOrder={false} />
      </ContentLogin>
    </>
  );
}

const ContentLogin = styled.div<StyledColor>`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // background: #3498db36;
  .login {
    margin: 3em 0;
    width: 30%;
    padding: 1em;
    border-radius: 12px;
    margin: 0 !important;
    @media screen and (max-width: 500px) {
      width: 100%;
    }

    header {
      text-align: center;
      padding: 1em;
      h1 {
        font-weight: bold;
        color: ${(props) => props.color.black};
      }
    }
    .form {
      div {
        padding: 0.5em 0;
      }
    }
  }
`;
